export default __webpack_public_path__ + "static/O0106-95be36a8beaf567b7569afe95e95fe9d.png";